module.exports = {
  name: 'Tiếng Việt',
  key: 'vi',
  'Open in Debug Map': 'Mở trong Bản đồ Gỡ lỗi',
  'Open in Mapillary': 'Mở trong Mapillary',
  'GPX': 'Xuất GPX file',
  'Open in editor': 'Mở trong chương trình vẽ',
  'Open in JOSM': 'Mở trong JOSM',
  'Select language': 'Chọn ngôn ngữ',
  'Share Route': 'Chia sẻ tuyến đường',
  'Link': 'Liên kết',
  'Shortlink': 'Liên kết rút gọn',
  'Start - press enter to drop marker': 'Khởi hành – bấm Enter để thả ghim',
  'End - press enter to drop marker': 'Đến – bấm Enter để thả ghim',
  'Via point - press enter to drop marker': 'Qua – bấm Enter để thả ghim',
  'Build': 'Build: '
};
